// Scroll Slider

gsap.registerPlugin(Observer)

window.addEventListener("DOMContentLoaded", () => {

    const section   = document.querySelector('.mwg028')
    const container = document.querySelector('.mwg028 .mwg028-container')
    const links     = document.querySelectorAll('.mwg028 .mwg028-link')  // werden translatiert UND rotiert
    if (!section || !container || links.length < 2) return

    // Container selbst nicht mehr transformieren — Karten translaten einzeln
    gsap.set(container, { clearProps: 'transform' })

    const N = links.length
    let step       = links[1].offsetLeft - links[0].offsetLeft  // Abstand zwischen Karten (Breite + Gap)
    let stripWidth = N * step
    // Wrap-Range symmetrisch um die natürlichen Karten-Positionen.
    // Karten teleportieren erst bei ±step/2 jenseits der Strip-Ränder → off-screen.
    let wrapMin = -step / 2
    let wrapMax = stripWidth - step / 2

    // Jede Karte einzeln positionieren. Wenn eine Karte beim Scrollen
    // an wrapMin/wrapMax kratzt (= off-screen), teleportiert NUR diese Karte
    // auf die andere Seite — sichtbare Karten bleiben kontinuierlich.
    const updateLinks = (t) => {
        for (let i = 0; i < N; i++) {
            const virtualPos   = i * step + t
            const displayedPos = gsap.utils.wrap(wrapMin, wrapMax, virtualPos)
            gsap.set(links[i], { x: displayedPos - i * step })
        }
    }
    updateLinks(0)

    // Proxy-Wert wird getweened, onUpdate verteilt's auf alle Links
    const proxy = { x: 0 }
    const xTo = gsap.quickTo(proxy, "x", {
        duration: 0.5,
        ease: 'power3',
        onUpdate: () => updateLinks(proxy.x)
    })

    const rotateTo = gsap.quickTo(links, "rotation", {
        duration: 1,
        ease: 'power3'
    })

    const ROTATION_INTENSITY = 60
    let total = 0
    const applyDx = (dx) => {
        total += dx
        xTo(total)
        rotateTo(-(dx / window.innerWidth) * ROTATION_INTENSITY)
    }

    // em-Sizing / Fluid-Scaling → bei Layout-Änderungen neu vermessen + repaint
    const ro = new ResizeObserver(() => {
        step       = links[1].offsetLeft - links[0].offsetLeft
        stripWidth = N * step
        wrapMin    = -step / 2
        wrapMax    = stripWidth - step / 2
        updateLinks(proxy.x)
    })
    ro.observe(container)

    gsap.matchMedia().add({
        isDesktop: '(min-width: 992px)',
        isMobile:  '(max-width: 991px)'
    }, (ctx) => {
        const { isDesktop } = ctx.conditions

        const obs = isDesktop
            ? Observer.create({
                target: section,
                type: 'wheel',
                preventDefault: true,
                wheelSpeed: 1,
                onWheel: (self) => applyDx(-self.deltaY),
                onStop: () => rotateTo(0)
              })
            : Observer.create({
                target: container,
                type: 'touch,pointer',
                onDrag: (self) => applyDx(self.deltaX),
                onRelease: () => rotateTo(0),
                onStop:    () => rotateTo(0)
              })

        return () => obs.kill()
    })
})


// Card Hover

document.querySelectorAll('.mwg028-link').forEach((link) => {
  const card    = link.querySelector('.mwg028-card');
  const preview = link.querySelector('.link-preview_wrapper');
  const screen  = link.querySelector('.screen-preview');

  if (!card || !preview) return;

  // Initial states
  gsap.set(card, { filter: 'blur(0px) brightness(1)', scale: 1, transformOrigin: 'center center' });
  gsap.set(preview, { yPercent: 5, autoAlpha: 0 });

  // Hover-Timeline
  const tl = gsap.timeline({
    paused: true,
    defaults: { duration: 0.6, ease: 'expo.inOut' }
  });

  tl.to(card, { filter: 'blur(8px) brightness(0.8)', scale: 1.02 }, 0)
    .to(preview, { yPercent: 0, autoAlpha: 1 }, 0);

  // Cursor-Follow (Osmo-Style): screen-preview folgt dem Cursor leicht
  const FOLLOW_STRENGTH = 15 // max. Pixel Verschiebung
  const followTarget    = screen || preview // Fallback wenn .screen-preview nicht existiert
  const followX = gsap.quickTo(followTarget, "x", { duration: 0.6, ease: "power2.out" });
  const followY = gsap.quickTo(followTarget, "y", { duration: 0.6, ease: "power2.out" });

  link.addEventListener('mouseenter', () => tl.play());

  link.addEventListener('mousemove', (e) => {
    const rect = link.getBoundingClientRect();
    const offsetX = (e.clientX - rect.left - rect.width  / 2) / rect.width;
    const offsetY = (e.clientY - rect.top  - rect.height / 2) / rect.height;
    followX(offsetX * FOLLOW_STRENGTH);
    followY(offsetY * FOLLOW_STRENGTH);
  });

  link.addEventListener('mouseleave', () => {
    tl.reverse();
    followX(0);
    followY(0);
  });
});